import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import * as Utils from '../../../../common/utilSvc';
import './SingleSource.css';
import { isNullOrUndefined } from "util";


class SingleSourceComponent extends React.Component {
    
    constructor(props){

        super(props);
        //id, link, text, editSource(id, type,val), isOpen, showSave

        this.state = {
            isEdit: true
        }

        this.handleChange = this.handleChange.bind(this);
        this.renderViewOnly = this.renderViewOnly.bind(this);
        this.renderEditable = this.renderEditable.bind(this);
        this.scrapeData = this.scrapeData.bind(this);

    }

    renderViewOnly(){
        return (
            <div className="SingleSourceTextContainer SingleSourceViewOnlyTextContainer">
                <p>{this.props.text}</p>
            </div>
        )
    }

    handleChange(event, type){
        if(type=="text"){
            let text = event.target.value;
            this.props.editSource(this.props.id, "text", text);
        }
        
    }

    async scrapeData(source){
        if(!isNullOrUndefined(source) && 'link' in source){
            //TODO Check if link is valid here

           
        
            const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/webscraperUrl';
            // console.log(endpoint);
            let res = await fetch(endpoint, 
                { 
                    method: 'POST', 
                    body: JSON.stringify({'url': source.link}),
                    headers: new Headers({'content-type': 'application/json'})
                }
                )
            .catch((err)=>{console.log(err)});  
            if(!isNullOrUndefined(res)){
                let text = await res.text();
                //TODO Format text here
                text = Utils.removeExtraLineSpaceFromText(text)
                this.props.editSource(this.props.id, "text", text);            
            } 
        }
    }

    renderEditable(){
        return (
            <div className="SingleSourceTextContainer SingleSourceEditTextContainer">
                <form>
                    <label>
                        <TextField 
                            type="text"
                            multiline
                            placeholder = "Enter summary"
                            value={this.props.text}
                            onSelect = {() => {this.props.selectSourceText(this.props.source)}}
                            onChange={(e) => { this.handleChange(e,"text")}}
                            rowsMin="4"
                            style={{
                                marginTop:'6px',
                                marginBottom:'6px',
                                width:'100%'
                                }}/>
                    </label>
                </form>
            </div>
        )
    }

    render(){
        return (
            <div>
                
                <div className="SingleSourceContainer" elevation={0}> 
                    <div className="SingleSourceLinkContainer">
                        <p>
                            Source: <a href={this.props.link} >{this.props.link}</a>
                            <IconButton color="primary" aria-label="expand" component="span" 
                                onClick={() => {this.props.toggleExpandButton(this.props.id)}}>
                                {this.props.isOpen?
                                    <ExpandLessIcon />
                                    :
                                    <ExpandMoreIcon />                                                
                                }                                            
                            </IconButton>                                    
                        </p>                                
                    </div>
                    
                    
                    {this.props.isOpen?
                        <div>                                
                            <div style={{marginTop:'10px'}}>
                                {!isNullOrUndefined(this.props.meetingSourceActivityString) && this.props.meetingSourceActivityString.trim()!=''?
                                    <div className="SingleSourceActivityContainer">
                                        <p>
                                            {this.props.meetingSourceActivityString}
                                        </p>
                                    </div>
                                    :
                                    null   
                                }
                                {this.state.isEdit?
                                    <div>
                                        {this.renderEditable()}
                                    </div>
                                    :
                                    <div>
                                        {this.renderViewOnly()}
                                    </div>
                                }
                            </div>
                            <div style={{display:'flex', flexWrap:'wrap', marginBottom:'10px'}}>
                                {this.state.isEdit?
                                    <div>
                                        <Button 
                                            color="primary"
                                            variant="contained"
                                            className="genericButton_v1" 
                                            onClick={() => {this.props.resetSource(this.props.id)}}>
                                                <div>Reset</div>
                                        </Button>
                                    </div>
                                    :
                                    null
                                }   
                                <div>
                                    <Button 
                                        color="primary"
                                        variant="contained"
                                        className="genericButton_v1" 
                                        onClick={() => {this.props.deleteSource(this.props.link)}}>
                                            <div>Delete</div>
                                    </Button>
                                </div> 
                                {this.props.showSave?
                                    <div>
                                        <Button 
                                            color="primary"
                                            variant="contained"
                                            className="genericButton_v1" 
                                            onClick={() => {this.props.saveSource(this.props.source)}}>
                                                <div>Save</div>
                                        </Button>
                                    </div> 
                                    :
                                    null
                                }  
                                <div>
                                    <Button 
                                        color="primary"
                                        variant="contained"
                                        className="genericButton_v1" 
                                        onClick={() => {this.scrapeData(this.props.source)}}>
                                            <div>Scrape Website</div>
                                    </Button>
                                </div>                          
                            </div>
                        </div>
                        :
                        null
                        }
                </div>
                   
            </div>
        )
    }
}
export default SingleSourceComponent;


/* 
WORKING CODE

const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/helloWorldRequest';
            console.log(endpoint);
            let res = await fetch(endpoint, 
                { 
                    method: 'POST', 
                    body: JSON.stringify({'url': source.link}),
                    headers: new Headers({'content-type': 'application/json'})
                }
                )
            .catch((err)=>{console.log(err)});          
            let ans = await res.text();
            console.log(ans);
*/